import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

// --- Pages Routing ---
import { PagesRoutingModule } from './pages-routing.module';

// --- Page ---
import { PagesComponent } from './pages.component';

// --- PrimeNG ---
import { ScrollTopModule } from 'primeng/scrolltop';
import { ToastModule } from 'primeng/toast';

// --- Components ---
import { DialogsModule } from '@components/dialogs/dialogs.module';
import { FooterModule } from '@components/footer/footer.module';
import { HeaderModule } from '@components/header/header.module';
import { WhatsAppButtonModule } from '@components/whatsapp-button/whatsapp-button.module';
import { SidebarModule } from '../components/sidebar/sidebar.module';

@NgModule({
	declarations: [PagesComponent],
	imports: [
		CommonModule,
		// --- Pages Routing ---
		PagesRoutingModule,
		// --- PrimeNG ---
		ScrollTopModule,
		ToastModule,
		// --- Components ---
		SidebarModule,
		DialogsModule,
		FooterModule,
		HeaderModule,
		WhatsAppButtonModule,
		SidebarModule,
	],
})
export class PagesModule {}
